<h5>{{ 'STEP5.question' | translate  }}</h5>
<kendo-textbox
  [ngClass]="emailError ? 'k-inputs-red red-placeholder' : 'k-inputs black-placeholder'"
  fillMode="flat"
  size="large"
  [placeholder]="'STEP5.yourEmail' | translate"
  [(ngModel)]="quotation.email"
  (input)="validateEmail()"
></kendo-textbox>

@if (userExistsError) {
  <small class="error-message">
    {{ 'STEP5.userExistsError' | translate }}
  </small>
}

<br/>
<i class="question">*{{ 'STEP5.description' | translate }}</i>
